import { Grid, styled } from '@mui/material';

export const StyledGridItem = styled(Grid)({
    '&.MuiGrid-item': {
        paddingLeft: '0 !important',
        maxWidth: '100%',
        width: '80%',
    },
});
